<div class="container" mat-dialog-content>
  <div class="switch-account-header w-full">
    <h2>Account Switch</h2>
  </div>
  <hr class="custom-hr">
  <div class="switch-account-detail w-full flex">
    <p class="switch-account-message">Could you please let me know if you are serious about <span>Switching</span> To <span>KingClub</span></p>
    <div class="switch-account-warning">
      <img src="{{icons.WarningGray}}" alt="warning icon">
      <p>There is no going back to the previous setting once this change has been made</p>
    </div>
    <div mat-dialog-actions class="switch-account-actions flex w-full">
      <p class="cancel-switch-account pointer" (click)="cancel()">Cancel</p>
      <button class="button switch-account-button flex w-full" (click)="switchAccount()">
        <span>Yes, I'm Sure</span>
      </button>
    </div>
  </div>
</div>